import { Routes, Route, Navigate } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
// import Dashboard from "./pages/Dashboard";
import PrivateRoute from "./routes/PrivateRoutes";

import HelpGuide from "./components/HelpGuide";
// import AgentExec from "./components/AgentExec";
// import DocumentAnalyzer from "./components/DocumentAnalyzer";
import Home from "./Home";
import ScrollToTopButton from "./elements/ScrollToTopButton";
import TranslatePanel from "./components/TranslatePanel";
import InsightPanel from "./components/InsightPanel";
import ScrollToTopOnRouteChange from "./elements/ScrollToTopOnRouteChange";
import AgentExec from "./components/AgentExec";
import AgentList from "./components/AgentPanel";
import DeepResearch from "./components/DeepResearch";
import DeepResearchFileSystem from "./elements/DeepResearchFileSystem";
import DeepResearchHistory from "./elements/DeepResearchHistory";
import DeepResearchQuestion from "./elements/DeepResearchQuestion";
import DeepResearchChat from "./elements/DeepResearchChat";
import Assistant from "./components/Assistant";
import Main from "./Main";
import { AuthProvider } from "./hooks/useAuth";
import isMobileUA from "./utils/isMobile";
import MobileBlocked from "./pages/MobileBlcoked";
import VirtualBizLabHome from "./components/VirtualBizLab";
import BizHistory from "./elements/BizHistory";
import BizRegist from "./elements/BizRegist";
import MeetingSummaryHome from "./components/MeetingSummaryHome";
import HybridAudioRecorder from "./elements/HybridAudioRecoder";
import MeetingRecords from "./elements/MeetingRecords";
import ProjectManagement from "./components/ProjectManagement";
import PerformanceManagement from "./components/PerformanceManagement";
import ScheduleManagement from "./components/ScheduleManagement";
import InitSettingPage from "./pages/InitSettingPage";
import { ToastContainer, useToast } from "./elements/Toast";
import IAMDashboard from "./pages/IAMDashboard";
import EDriveDashboard from "./pages/EdriveDashboard";
import FinancePage from "./pages/FinancePage";
import TableView from "./components/Finance/Tables/TableView";
import CalendarApp from "./pages/CalendarApp";
import EwiChat from "./components/Ewi/EwiChat";

import ResetPasswordPage from "./components/Auth/ResetPasswordPage";
import SignupPage from "./components/Auth/SignupPage";
import KnowledgeDatabasePage from "./pages/KnowledgeDBPage";
import SmartDocumentListPage from "./pages/SmartDocumentListPage";
import SmartDocumentEditPage from "./pages/SmartDocumentEditPage";

export default function App() {
  const { toasts, showToast } = useToast();
  window.showToast = showToast;
  return (
    <>
      <ScrollToTopOnRouteChange />
      <ToastContainer toasts={toasts} />
      <Routes>
        <Route path="/" element={<Main />} />

        {isMobileUA() ? (
          <Route path="*" element={<MobileBlocked />} />
        ) : (
          <>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/sig_pagi_signup" element={<SignupPage />} />
            <Route
              path="/sig_reset_forget_xpow"
              element={<ResetPasswordPage />}
            />
            <Route element={<PrivateRoute />}>
              <Route path="/project_setting" element={<InitSettingPage />} />
              <Route path="/app" element={<Home />} />
              <Route path="/financial_management" element={<FinancePage />} />
              <Route
                path="/financial_management/tableView/:tableId"
                element={<TableView />}
              />
              <Route path="/assistant" element={<EwiChat />} />
              <Route path="/edrive" element={<EDriveDashboard />} />
              <Route
                path="/knowledge_database_section"
                element={<KnowledgeDatabasePage />}
              />
              <Route
                path="/smart_editor_section"
                element={<SmartDocumentListPage />}
              />
              <Route
                path="/smart_editor_section/:sessionId"
                element={<SmartDocumentEditPage />}
              />
              <Route path="/schedule_management" element={<CalendarApp />} />
              <Route path="/iam_dashboard" element={<IAMDashboard />} />
              <Route path="/help_guide/:sessionId?" element={<HelpGuide />} />
              {/* <Route path="/assistant" element={<Assistant />} /> */}
              <Route path="/translate" element={<TranslatePanel />} />
              <Route path="/insight" element={<InsightPanel />} />
              <Route path="/deep_research" element={<DeepResearch />} />
              <Route
                path="/deep_research/filesystem"
                element={<DeepResearchFileSystem />}
              />
              <Route
                path="/deep_research/history"
                element={<DeepResearchHistory />}
              />
              <Route
                path="/deep_research/prebuild"
                element={<DeepResearchQuestion />}
              />
              <Route
                path="/deep_research/chat"
                element={<DeepResearchChat />}
              />
              <Route path="/vcompany" element={<VirtualBizLabHome />} />
              <Route path="/vcompany/biz" element={<BizHistory />} />
              <Route path="/vcompany/realize" element={<BizRegist />} />
              <Route path="/agent_library" element={<AgentList />} />
              <Route path="/agent_exec" element={<AgentExec />} />

              <Route path="/meeting_summary" element={<MeetingSummaryHome />} />
              <Route
                path="/meeting_summary/start"
                element={<HybridAudioRecorder />}
              />
              <Route
                path="/meeting_summary/records"
                element={<MeetingRecords />}
              />
              {/* 정의되지 않은 경로는 /app으로 리다이렉트 */}
              <Route path="*" element={<Navigate to="/app" replace />} />
            </Route>
          </>
        )}
      </Routes>
      <ScrollToTopButton />
    </>
  );
}
